import { render, staticRenderFns } from "./dal-comp-banner.vue?vue&type=template&id=c4a7c8f0&scoped=true"
import script from "./dal-comp-banner.vue?vue&type=script&lang=js"
export * from "./dal-comp-banner.vue?vue&type=script&lang=js"
import style0 from "./dal-comp-banner.vue?vue&type=style&index=0&id=c4a7c8f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a7c8f0",
  null
  
)

export default component.exports